/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import Image from 'gatsby-image';
import convertJsonToPropsInLocale from './convert-json-to-props-in-locale';
import { getContentfulGatsbyImage } from './image-lookup';

const defaultLocale = 'en-US';

const EmbeddedAsset = ({ data }) => {
  const { target } = convertJsonToPropsInLocale(
    data, defaultLocale, ({ id }) => getContentfulGatsbyImage(id),
  );
  return <Image fluid={target.fluid} alt={target.title} sx={{ my: '4.8rem' }} />;
};

EmbeddedAsset.propTypes = {
  data: PropTypes.object.isRequired,
};

export default EmbeddedAsset;
